import { QuotationDeliverable } from '@teem/models/quotation-deliverable';
import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import * as moment from 'moment';


export class QuotationSerializer implements Serializer {
	fromJson(json: any): Quotation {
		let quote = new Quotation(json);
		return quote;
	}

	toJson(quote: Quotation): any {
		return quote;
	}
}

export class Quotation implements Resource {
	public uuid: string;
	public title: string;
	public quotation_number: number;
	public quotation_date: string = moment().format('DD/MM/YYYY');
	public client_id: number = null;
	public status: string = 'pending';
	public is_draft: number = 0;
	// public total_amount:number = 0;
	public total_amount:number = 0;
	public sub_total: number = 0;
	public discount: number;
	public delivery_fee: number;
	
	public original_amount: number;
	public discounted_amount: number;
	public additional_info: string;
	public project_type: string = 'fixed';
	public include_tax: boolean;
	public tax_percent: number;
	public tax_type: number;
	// public deliverables: InvoiceDeliverable[] = []; // Todo - duplicate keys of items and deliverables. Need to remove one
	public items: QuotationDeliverable[];
	public online_payment_percent: number = 0;
	public action: string = null;
	public save_default_payment_info: boolean = false;
	public save_default_additional_info: boolean = false;
	public client: any;
	public client_name: string;
	public client_email: string;
	public discount_type: string = 'percentage';
	public invoice_id: number;
	public user: any;
	public client_has_email: boolean = true;
	public reason: string;
	public currency: string;


	constructor(input?: any) {

		if (input) {
			Object.assign(this, input);

			if (input.items && input.items.length) {
				this.items = [];
				input.items.forEach(item => {
					this.items.push(new QuotationDeliverable(item))
				});
			}
		}
	}
}
